import React, { useEffect, useState } from "react";
import convertDate from "./convertDate";
import Loading from "./loading";
import ReloadButton from "./reloadButton";
import { LightAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { vs, vs2015 } from "react-syntax-highlighter/dist/esm/styles/hljs";
import uploadFile from "./uploadFileToS3";
import validateDockerfile from "./validateDockerfile";
import DownloadItems from "./downloadItems";

const DockerfileInfo = ({ updateDockerfiles, requestLifeCycle, updateDockerArray, dockerfile, dockerfileText, isDarkTheme }) => {
    const [requestLifeCycleDockerfile, setRequestLifeCycleDockerfile] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [initial, setInitial] = useState(true);

    // have separate state for files
    const findJsonDockerLog = () => {
        try {
            const data = dockerfile.dockerLogs;
            if (data) {
                return data
            }

            return null;

        } catch (error) {
            console.log(error);
            return "Docker Log is a not valid string"
        }
    }

    const findShowDockerLogs = () => {
        try {
            const data = dockerfile.dockerLogs;
            if (data) {
                return true
            }

            return false;

        } catch (error) {
            console.log(error);
            return false
        }
    }

    const fetchDockerInfo = async () => {
        try {
            setRequestLifeCycleDockerfile(true);
            const res = await fetch( process.env.REACT_APP_USER_API_URL + `/get-account-information`, {
                method: "GET",
                credentials: "include"
            });
            const data = await res.json();
            if (res.status === 200) {
                for (let i = 0; i < data?.dockerArray?.length; i++) {
                    if (data.dockerArray[i].dockerUuid === dockerfile.dockerUuid) {
                        updateDockerArray(dockerfile.dockerUuid, data.dockerArray[i]);
                    }
                }
            } else if (res.status === 401) {
                window.location.href = process.env.REACT_APP_401_REDIRECT_URL;
            } else {
                alert("Status Code: " + res.status + " Error: " + data.detail);
            }
            
    
        } catch (error) {
            alert("Error: " + error.message);
            console.log(error);
        } finally {
            setRequestLifeCycleDockerfile(false);
        }
    }

    const updateName = (name) => {
        updateDockerArray(dockerfile.dockerUuid, {
            ...dockerfile,
            name
        })
    }

    const updateNameBackend = () => {
        if (initial) {
            setInitial(false);
            return;
        }
        
        if (dockerfile?.name?.trim() === "") {
            return;
        }

        try {
            const url = process.env.REACT_APP_EVALUATION_API_URL + `/update-docker-name/${dockerfile.dockerUuid}`;
            const urlOptions = {
                method: "POST",
                credentials: "include",
                headers: {
                    'Content-Type': "application/json"
                },
                body: JSON.stringify({
                    name: dockerfile.name
                })
            }
            fetch(url, urlOptions);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            updateNameBackend();
        }, 500)

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        }

    }, [dockerfile?.name])

    const validateDockerfileAsync = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            
            reader.onload = (event) => {
                const content = event.target.result;
                const [isValid, msg] = validateDockerfile(content);
    
                if (!isValid) {
                    reject(new Error("Invalid Dockerfile"));
                } else {
                    resolve(content);
                }
            };
    
            reader.readAsText(file);
        });
    };

    const submitDockerForm = async (newDockerfile) => {
        if (requestLifeCycleDockerfile) {
            return;
        }

        if (newDockerfile?.name === "") {
            alert("Please enter a valid name")
            return
        }

        if (newDockerfile && newDockerfile?.name?.toLowerCase() !== 'dockerfile') {            
            alert("Dockerfile input's name is not \"Dockerfile\"");
            return;
        }

        let dockerfileNewText = null;

        try {
            dockerfileNewText = await validateDockerfileAsync(newDockerfile);
        } catch (error) {
            console.log(error);
            alert("Dockerfile error: " + error.message);
            return;
        }

        const url = process.env.REACT_APP_EVALUATION_API_URL + `/update-dockerfile/${dockerfile?.dockerUuid}`;

        const urlOptions = {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                name: dockerfile?.name
            })
        };

        try {
            setRequestLifeCycleDockerfile(true);
            const res = await fetch(url, urlOptions);
            const data = await res.json();
            if (res.status === 200) {
                if (data.url && newDockerfile) {
                    const imageStatus = await uploadFile(newDockerfile, data.url, "text/plain");
                    
                    if (imageStatus !== 200) {
                        alert("Docker image failed to upload");
                        return;
                    }
                }

                updateDockerArray(dockerfile.dockerUuid, data.dockerfile);
                updateDockerfiles(dockerfile.dockerUuid, dockerfileNewText);

            } else if (res.status === 400 || res.status === 415) {
                alert(data.detail);
            } else {
                alert("Status Code: " + res.status + " Error: " + data.detail);
            }

        } catch (error) {
            alert("Error: " + error.message)
            console.log(error);
        } finally {
            setRequestLifeCycleDockerfile(false)
        }
    }

    const dockerIcon = (
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" color="currentColor" width="20" height="20" viewBox="0 0 640 512">
            <path color="currentColor" d="M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4 .4 67.6 .1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"/>
        </svg>
    )

    const downloadDockerfile = () => {
        const element = document.createElement('a');
        const blob = new Blob([dockerfileText], { type: 'text/x-dockerfile' });
        const fileUrl = URL.createObjectURL(blob);
        element.setAttribute('href', fileUrl);
        element.setAttribute('download', 'Dockerfile');
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        URL.revokeObjectURL(fileUrl);
    };

    return (
        <>
            <div className="docker-container" style={{ fontWeight: "400" }}>                                                        
                {
                    requestLifeCycleDockerfile ?

                    <div className="loading-container" style={{ height: "100px" }}>
                        <Loading />
                    </div>

                    :

                    <>

                        <div className="key-value" style={{ textWrap: "nowrap" }}>
                            Update Dockerfile:
                            <input type="file" className="pdf-choose" onChange={(e) => {submitDockerForm(e.target.files[0])}} accept=""/>
                        </div>
                        <div className="key-value">
                            Build Start: {convertDate(dockerfile.lastDockerStartTime, true)}
                            <div onClick={fetchDockerInfo}>
                                <ReloadButton size={12.5}/>
                            </div>
                        </div>
                        <div className="key-value">
                            Status: <span className="apply-remove remove">{dockerfile.dockerStatus === 'RUNNING' ? 'Running' : "Finished"}</span>
                        </div>
                        <div className="key-value" style={{ textWrap: "nowrap" }}>
                            Name:
                            <input onBlur={updateNameBackend} className="bottom-input" style={{ backgroundColor: "transparent" }} value={dockerfile.name} onChange={(e) => {updateName(e.target.value)}}/>
                        </div>
                            <div className="metric-select question-2" onClick={() => {
                                    setIsOpen((prev) => !prev);                                    
                                }}>
                                Errors
                                <div className="center-chevron">
                                    {
                                        isOpen ?

                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                        </svg>

                                        :

                                        
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                            <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                                        </svg>

                                    }
                                </div>
                            </div>
                            {
                                isOpen && findShowDockerLogs() ? <div className="key-value-logs"> {findJsonDockerLog()} </div> : <></>
                            }
                            <div style={{ marginTop: "10px", width: "100%" }}>
                                <DownloadItems svg={dockerIcon} label={"Download Dockerfile"} width={"100%"} handleClick={downloadDockerfile}/>
                            </div>                            
                            {
                                dockerfileText && (
                                    requestLifeCycle ?

                                    <div className="loading-container" style={{ height: "100px" }}>
                                        <Loading />
                                    </div>

                                    :
                                    
                                    <SyntaxHighlighter customStyle={{ width: "100%", marginTop: "10px", fontSize: "14px", borderRadius: "5px", padding: "15px", wordBreak: "break-all", backgroundColor: !isDarkTheme ? "var(--gray-one)" : "black", border: !isDarkTheme ? "2px solid var(--gray-four)" : "black" }} language="dockerfile" style={isDarkTheme ? vs2015 : vs}>
                                        {dockerfileText}
                                    </SyntaxHighlighter>
                                )
                            }                         
                    </>
                }
            </div>
        </>
    );
}

export default DockerfileInfo;